angular
    .module('lingoda.fields.select', [])
    .directive('resposelectList', [
        '$timeout',
        '$filter',
        function ($timeout, $filter) {
            return {
                restrict: 'C',
                scope: true,
                link: function (scope, element) {
                    var hide = function () {
                        scope.relatedScope.active = false;
                        scope.relatedScope = false;
                    };
                    scope.refreshPosition = function () {
                        if (!scope.relatedScope) {
                            return true;
                        }

                        var top = scope.relatedScope.getElement()[0].getBoundingClientRect().top,
                            left = scope.relatedScope.getElement()[0].getBoundingClientRect().left,
                            height = scope.relatedScope.getElement()[0].offsetHeight,
                            width = scope.relatedScope.getElement()[0].offsetWidth,
                            x =
                                window.innerWidth ||
                                document.documentElement.clientWidth ||
                                document.body.clientWidth,
                            y =
                                window.innerHeight ||
                                document.documentElement.clientHeight ||
                                document.body.clientHeight,
                            centerEdge = (width - element[0].offsetWidth) / 2,
                            centerCheck =
                                left + centerEdge > 0 &&
                                left + centerEdge + element[0].offsetWidth <= x,
                            rightCheck = left + element[0].offsetWidth > x,
                            bottomCheck =
                                top + height + element[0].offsetHeight > y &&
                                top - element[0].offsetHeight > 0,
                            maxHeight = y / 3;

                        if (rightCheck) {
                            if (centerCheck) {
                                scope.positionX = 'center';
                                left = left + centerEdge;
                            } else {
                                scope.positionX = 'right';
                                left = left - (element[0].offsetWidth - width);
                            }
                        } else {
                            scope.positionX = 'left';
                        }

                        if (!bottomCheck) {
                            top = top + height;
                            scope.positionY = 'top';
                        }

                        height = 0;
                        element.find('li').each(function (i, element) {
                            height += element.offsetHeight;
                            if (height > maxHeight) {
                                height = maxHeight - 2;
                                return false;
                            }
                        });

                        if (bottomCheck) {
                            top = top - height - 12;
                        }

                        element.css({
                            top: top + 'px',
                            left: left + 'px',
                            height: height + 2,
                        });
                        if (scope.relatedScope && scope.relatedScope.width != 'default') {
                            element.css({
                                width: (width / 100) * parseInt(scope.relatedScope.width),
                            });
                        } else if (
                            !scope.relatedScope.width ||
                            scope.relatedScope.width == 'default'
                        ) {
                            element.css({
                                width: 250,
                            });
                        }

                        element.css({
                            minWidth: scope.relatedScope.getElement().hasClass('form-select')
                                ? width
                                : 0,
                        });

                        scope.iscroll.refresh();
                    };

                    scope.scrollToActive = function () {
                        if (angular.isDefined(scope.activeIndex)) {
                            var target = element[0].querySelector(
                                'li:nth-child(' + (scope.activeIndex + 1) + ')',
                            );
                            if (target) {
                                scope.iscroll.scrollToElement(target, 0);
                            }
                        }
                    };

                    //Select after click
                    scope.select = function (item) {
                        scope.relatedScope.setItem(item);
                        hide();
                    };

                    scope.$parent.$on('resposelect:list:show', function (e, selectScope) {
                        if (scope.relatedScope) {
                            scope.relatedScope.active = false;
                        }
                        scope.relatedScope = selectScope;
                        scope.activeIndex = scope.relatedScope.activeIndex;
                        $timeout(scope.refreshPosition);
                        scope.$apply();
                    });

                    scope.$watch('relatedScope', function (relatedScope) {
                        if (relatedScope) {
                            $timeout(function () {
                                scope.active = true;
                                scope.refreshPosition();
                                $timeout(function () {
                                    scope.refreshPosition();
                                    scope.scrollToActive();
                                    $timeout(scope.refreshPosition);
                                });
                            });
                        } else {
                            scope.active = false;
                        }
                    });

                    //Mobile
                    element.bind('touchstart', function (e) {
                        e.stopPropagation();
                    });

                    //Blur
                    $(document).bind('click', function (e) {
                        if (!scope.relatedScope) {
                            return true;
                        }
                        if (
                            !$(e.target).closest(element).length &&
                            !$(e.target).closest(scope.relatedScope.getElement()).length
                        ) {
                            scope.$apply(hide);
                        }
                    });
                    //Keep the position
                    $(window).bind('resize scroll', scope.refreshPosition);

                    //Keyboard navigation
                    var filteredWord = '',
                        filterTimeoutID = null;
                    $(document).on('keydown', function (e) {
                        if (!scope.relatedScope) {
                            return true;
                        }

                        if ((e.keyCode > 36 && e.keyCode < 41) || e.keyCode === 32) {
                            e.preventDefault();
                        }

                        //Space
                        if (e.keyCode === 32) {
                            scope.relatedScope.setItem(scope.relatedScope.items[scope.activeIndex]);
                            if (scope.relatedScope.item && scope.relatedScope.item.href) {
                                window.location = scope.relatedScope.item.href;
                            }
                            hide();
                        }
                        //Up
                        else if (e.keyCode === 38) {
                            scope.activeIndex > 0 && scope.activeIndex--;
                            scope.scrollToActive();
                        }
                        //Down
                        else if (e.keyCode === 40) {
                            scope.activeIndex < scope.relatedScope.items.length - 1 &&
                                scope.activeIndex++;
                            scope.scrollToActive();
                        }
                        //Tab
                        else if (e.keyCode === 9) {
                            hide();
                        }
                        //Esc
                        else if (e.keyCode === 27) {
                            hide();
                        }
                        //Enter
                        else if (e.keyCode === 13) {
                            e.preventDefault();
                            scope.relatedScope.setItem(scope.relatedScope.items[scope.activeIndex]);
                            if (scope.relatedScope.item && scope.relatedScope.item.href) {
                                window.location = scope.relatedScope.item.href;
                            }
                            hide();
                        } else {
                            //Filter
                            $timeout.cancel(filterTimeoutID);
                            filteredWord += String.fromCharCode(e.which);
                            var result = $filter('filter')(
                                scope.relatedScope.items,
                                function (item) {
                                    if (
                                        item.text
                                            .toLowerCase()
                                            .trim()
                                            .substr(0, filteredWord.length) ===
                                        filteredWord.toLowerCase()
                                    ) {
                                        return true;
                                    }
                                },
                            );
                            if (result && result[0]) {
                                scope.activeIndex = result[0].i;
                                scope.scrollToActive();
                            }
                            filterTimeoutID = $timeout(function () {
                                filteredWord = '';
                            }, 500);
                        }
                        scope.$apply();
                    });
                },
            };
        },
    ])
    .directive('resposelectListItem', function () {
        return {
            restrict: 'C',
            link: function (scope, element) {
                element.on('mouseover', function () {
                    if (!scope.item.disabled && scope.item.type == 'OPTION') {
                        if (scope.$parent) {
                            scope.$parent.activeIndex = scope.$index;
                            scope.$parent.$apply();
                        }
                    }
                });
                element.on('click', function (e) {
                    if (scope.item.disabled && scope.item.type == 'OPTGROUP') {
                        e.preventDefault();
                        e.stopPropagation();
                    } else if (scope.item.type == 'OPTION') {
                        scope.select(scope.item);
                        scope.$apply();
                    }
                });
            },
        };
    })
    .directive('resposelectListContent', function () {
        return {
            restrict: 'C',
            link: function (scope, element) {
                scope.iscroll = new IScroll(element[0], {
                    scrollbars: true,
                    mouseWheel: true,
                    interactiveScrollbars: true,
                    shrinkScrollbars: 'scale',
                    fadeScrollbars: false,
                    click: true,
                });
            },
        };
    })
    .directive('resposelectWrapper', [
        '$compile',
        '$timeout',
        '$parse',
        function ($compile, $timeout, $parse) {
            return {
                restrict: 'C',
                scope: true,
                link: function (scope, element, attrs) {
                    scope.valid = {
                        input: true,
                        select: true,
                    };

                    scope.syncValidation = function () {
                        if (scope.valid.input && scope.valid.select) {
                            element.addClass('ng-valid');
                            element.removeClass('ng-invalid');
                        } else {
                            element.addClass('ng-invalid');
                            element.removeClass('ng-valid');
                        }
                    };

                    scope.click = function (e) {
                        e.preventDefault();

                        if (!scope.active) {
                            scope.active = true;
                            scope.$emit('resposelect:list:show', scope);
                            if (document.activeElement != element[0]) {
                                element[0].focus();
                            }
                        } else {
                            element[0].blur();
                        }
                    };

                    scope.getElement = function () {
                        return element;
                    };

                    element.bind('click', scope.click);

                    element.on('keydown', function (e) {
                        if ((e.keyCode > 36 && e.keyCode < 41) || e.keyCode === 32) {
                            e.preventDefault();
                        }

                        //Space
                        if (e.keyCode === 32) {
                            if (!scope.active) {
                                e.stopPropagation();
                                scope.active = true;
                                scope.$emit('resposelect:list:show', scope);
                            }
                        }
                        //Up
                        else if (e.keyCode === 38) {
                            if (!scope.active) {
                                e.stopPropagation();
                                scope.active = true;
                                scope.$emit('resposelect:list:show', scope);
                            }
                        }
                        //Down
                        else if (e.keyCode === 40) {
                            if (!scope.active) {
                                e.stopPropagation();
                                scope.active = true;
                                scope.$emit('resposelect:list:show', scope);
                            }
                        }
                    });

                    if (attrs.itemModel) {
                        scope.$watch('item', function (v) {
                            $parse(attrs.itemModel).assign(scope.$parent, v);
                        });
                    }
                },
            };
        },
    ])
    .directive('resposelect', [
        '$compile',
        '$timeout',
        function ($compile, $timeout) {
            return {
                restrict: 'C',
                require: 'ngModel',
                link: function (scope, iElement, iAttr, ngModel) {
                    iAttr.$set('tabindex', '-1');

                    scope.width = iAttr.width || 'default';

                    scope.active = false;
                    scope.data = iElement.data();

                    scope.buildList = function (init) {
                        var items = [],
                            selectedItem = null,
                            i = 0,
                            pushElement = function (item, parentItem) {
                                var text =
                                        item.nodeName === 'OPTION'
                                            ? angular.element(item).text()
                                            : angular.element(item).attr('label'),
                                    currentItem = angular.extend(
                                        {
                                            value: angular.element(item).val(),
                                            hide: angular.element(item).hasClass('ng-hide')
                                                ? true
                                                : false,
                                            text: text,
                                            type: item.nodeName,
                                            i: i,
                                            disabled:
                                                !!angular.element(item).attr('disabled') ||
                                                !!angular.element(parentItem).attr('disabled'),
                                            selected:
                                                (ngModel.$modelValue ==
                                                    angular.element(item).val() &&
                                                    item.nodeName === 'OPTION') ||
                                                (!ngModel.$modelValue &&
                                                    init &&
                                                    angular.element(item).attr('selected')) ||
                                                (!init &&
                                                    ngModel.$modelValue ==
                                                        angular.element(item).val() &&
                                                    item.nodeName === 'OPTION'),
                                        },
                                        angular.element(item).data(),
                                    );

                                if (currentItem.selected) {
                                    scope.activeIndex = i;
                                }

                                //Array
                                currentItem.prepend =
                                    typeof currentItem.prepend === 'string'
                                        ? scope.$eval(currentItem.prepend)
                                        : currentItem.prepend;
                                currentItem.append =
                                    typeof currentItem.append === 'string'
                                        ? scope.$eval(currentItem.append)
                                        : currentItem.append;

                                items.push(currentItem);
                                selectedItem = currentItem.selected ? currentItem : selectedItem;

                                i++;
                            },
                            buildUp = function (currentItems, parentItem) {
                                angular.forEach(currentItems, function (item) {
                                    pushElement(item, parentItem);
                                    if (item.nodeName === 'OPTGROUP') {
                                        buildUp(angular.element(item).children(), item);
                                    }
                                });
                            };

                        buildUp(iElement.children(), null);

                        scope.items = items;

                        return selectedItem;
                    };

                    scope.setItem = function (item) {
                        if (angular.isDefined(item)) {
                            if (item === null) {
                                ngModel.$setViewValue(item);
                            } else if (angular.isDefined(item.value)) {
                                ngModel.$setViewValue(item.value);
                                scope.item = item;
                                scope.field = {
                                    display: item.text,
                                    value: item.value,
                                };
                            }
                        }
                    };

                    var changeCounter = 0;
                    scope.$watch(iAttr.ngModel, function (v) {
                        if (angular.isDefined(v)) {
                            $timeout(function () {
                                iElement.val(v);
                                scope.$emit('resposelect:list:refresh', scope);
                                changeCounter++;
                                scope.$emit('resposelect:change', v, changeCounter);
                            });

                            var newItem = scope.buildList();
                            if (newItem) {
                                scope.setItem(newItem);
                            }
                        }

                        if (iElement.parents('.form-select').length) {
                            scope.valid.select = ngModel.$valid;
                            scope.syncValidation();
                        }
                    });

                    var ie9 = $('html').hasClass('ie9');
                    iElement.bind('mousedown', function (e) {
                        e.preventDefault();
                        if (ie9) {
                            scope.click(e);
                        }
                    });

                    $timeout(function () {
                        scope.setItem(scope.buildList(true));
                    });

                    scope.$on('resposelect:list:build', function () {
                        scope.buildList();
                    });
                },
            };
        },
    ])
    .directive('resposelectInput', function () {
        return {
            restrict: 'C',
            require: 'ngModel',
            link: function (scope, iElement, iAttr, ngModel) {
                scope.$watch(iAttr.ngModel, function () {
                    scope.valid.input = ngModel.$valid;
                    scope.syncValidation();
                });
            },
        };
    });
